export enum Routes {
  LoginPage = "/login",
  ForgotPasswordPage = "/forgot-password",
  HomePage = "/",
  OfflinePage = "/offline",
  UnauthorizedPage = "/unauthorized",
}
